const initialState = {
	button: false,
	loaded: false,
	records: [],
	error: false,
	error_message: [],
	success: false
}

export default function professionalReducers( state = initialState, action) {
	switch(action.type) {
		case 'PROF_BUTTON': {
			return {
				...state,
				button: true
			}
		}
		case 'PROF_BUTTON_OFF': {
			return {
				...state,
				button: false
			}
		}
		case 'PROF_ERROR': {
			return {
				...state,
				button: false,
				error: true,
				error_message: action.payload,
				success: false
			}
		}
		case 'PROF_SUCCESS': {
			return {
				...state,
				button: false,
				error: false,
				error_message: [],
				success: true,
				loaded: false,
			}
		}
		case 'PROF_SUCCESS_OFF': {
			return {
				...state,
				success: false
			}
		}
		case 'PROF_ERROR_OFF': {
			return {
				...state,
				error: false,
				error_message: [],
				button: false
			}
		}
		case 'PROF_RECORDS': {
			return {
				...state,
				loaded: true,
				records: action.payload
			}
		}
		default: return state;
	}
}